// extracted by mini-css-extract-plugin
module.exports = {"container":"Vn-z","heading":"Wn-z","links":"Xn-z","linkBtn":"Yn-z","disabled":"Zn-z","linkUppercaseBold":"_n-z","copy":"ao-z","subCopy":"bo-z"};